export const viguideVersion = '2.53.1';
